import { ADD_COLOR, DELETE_BRAND, GET_COLOR, UPDATE_COLOR, GET_ONE_COLOR} from "../types";
  
  const initialState = { list: [], single: null,
    pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
    },
  };
  
  const reducer = (state = initialState, action) => {
    const { type, payload } = action;
  
    switch (type) {
      case GET_COLOR:
        return { ...state, list: payload.data , pagination: payload.pagination };
  
      case UPDATE_COLOR:
        return {
          ...state,
          list: state.list.map((item) =>
            item.id === payload.id ? payload : item
          ),
        };
  
      case ADD_COLOR:
        return {
          ...state,
          list: [payload, ...state.list],
        };
  
      case DELETE_BRAND:
        return {
          ...state,
          list: state.list.filter((item) => item.id !== payload.id),
        };

      case GET_ONE_COLOR:
        return { ...state, single: payload };
  
      default:
        return state;
    }
  };
  
  export default reducer;
  